<template>
  <div class="node-palette">
    <div class="palette-header">
      <h6>Adicionar Step</h6>
    </div>

    <div class="palette-categories">
      <div v-for="category in filteredCategories" :key="category.id" class="category-section">
        <div class="category-header" @click="toggleCategory(category.id)">
          <i :class="category.icon" class="mr-1"></i>
          <span>{{ category.label }}</span>
          <i class="bx" :class="expandedCategories.includes(category.id) ? 'bx-chevron-up' : 'bx-chevron-down'" style="margin-left:auto"></i>
        </div>

        <div class="category-nodes" v-show="expandedCategories.includes(category.id)">
          <div
            v-for="node in category.nodes"
            :key="node.kind"
            class="palette-node"
            @click="$emit('add-node', node)"
          >
            <div class="node-icon" :style="{ background: node.color + '1a', color: node.color }">
              <i :class="node.icon"></i>
            </div>
            <div class="node-info">
              <span class="node-label">{{ node.label }}</span>
              <span class="node-desc">{{ node.description }}</span>
            </div>
            <i class="bx bx-plus add-icon"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { nodeCategories } from '../nodeLibrary'

export default {
  data () {
    return {
      expandedCategories: ['triggers', 'delays', 'actions', 'conditions', 'control']
    }
  },
  computed: {
    filteredCategories () {
      return nodeCategories
    }
  },
  methods: {
    toggleCategory (id) {
      const idx = this.expandedCategories.indexOf(id)
      if (idx === -1) {
        this.expandedCategories.push(id)
      } else {
        this.expandedCategories.splice(idx, 1)
      }
    }
  }
}
</script>

<style scoped>
.node-palette {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.palette-header {
  padding: 16px 16px 12px;
  border-bottom: 1px solid #e9ecef;
}
.palette-header h6 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #344054;
}

/* Categories - scroll on hover */
.palette-categories {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
  scrollbar-width: thin;
  scrollbar-color: transparent transparent;
}
.palette-categories:hover {
  scrollbar-color: #d0d5dd transparent;
}
.palette-categories::-webkit-scrollbar { width: 5px; }
.palette-categories::-webkit-scrollbar-track { background: transparent; }
.palette-categories::-webkit-scrollbar-thumb { background-color: transparent; border-radius: 3px; }
.palette-categories:hover::-webkit-scrollbar-thumb { background-color: #d0d5dd; }
.palette-categories::-webkit-scrollbar-thumb:hover { background-color: #b0b5bd; }

.category-section { margin-bottom: 4px; }

.category-header {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: #495057;
  background: #f8f9fa;
  border-radius: 8px;
  transition: all 0.15s;
}
.category-header:hover { background: #f0f2f5; }
.category-header i.mr-1 { font-size: 16px; color: #556ee6; }

.category-nodes { padding: 8px 0 8px 8px; }

/* Palette node - matches FieldPalette field-item */
.palette-node {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 8px;
  margin-bottom: 6px;
  cursor: pointer;
  transition: all 0.15s;
}
.palette-node:last-child { margin-bottom: 0; }
.palette-node:hover {
  border-color: #556ee6;
  background: #f8f9ff;
  box-shadow: 0 2px 4px rgba(85, 110, 230, 0.1);
}
.palette-node:hover .add-icon { opacity: 1; }

.node-icon {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  flex-shrink: 0;
}

.node-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.node-label {
  font-size: 13px;
  font-weight: 500;
  color: #344054;
}
.node-desc {
  font-size: 11px;
  color: #9ca3af;
  margin-top: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Add button - matches FieldPalette btn-add */
.add-icon {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: #556ee6;
  color: #fff;
  border-radius: 6px;
  font-size: 16px;
  opacity: 0;
  transition: all 0.15s;
  flex-shrink: 0;
}
.palette-node:hover .add-icon { opacity: 1; }
.add-icon:hover { background: #485ec4; }
</style>
